import type { FC } from 'react';
import type { IProps } from '@/Module/Core/Model/DataModel';
import { DefaultLayoutHeader } from '@/Module/DefaultLayout/Component';
const ErrorLayout: FC<IProps> = ({
  children
}) => {
  return <>
      <DefaultLayoutHeader data-sentry-element="DefaultLayoutHeader" data-sentry-source-file="ErrorLayout.tsx" />
      {children}
    </>;
};
export default ErrorLayout;